module.exports = __webpack_public_path__ + "img/image-consultant-mirela.3b36262b.png";